"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationRequest = void 0;
var VerificationRequest = /** @class */ (function () {
    function VerificationRequest() {
    }
    return VerificationRequest;
}());
exports.VerificationRequest = VerificationRequest;
;
//# sourceMappingURL=verification.request.js.map